import React from 'react';
import styles from './impersonation-border.module.scss';

export const IMPERSONATION_BORDER_TEST_ID = 'impersonation-border';

/**
 * Full-viewport blue frame shown while an impersonation ("act as") session is
 * active — a persistent, non-interactive indicator (Figma observation-mode
 * style) that the current session is being impersonated. Rendered as a fixed
 * overlay so it frames the whole app without affecting layout or blocking input.
 */
export const ImpersonationBorder: React.FC = () => (
    <div
        className={styles.border}
        aria-hidden="true"
        data-testid={IMPERSONATION_BORDER_TEST_ID}
    />
);
